import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Alabama = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Alabama Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Buyer is responsible for discovering home defects; no specific
          disclosure form required.
        </Text>

        <Text style={styles.listItem}>
          2. Disclosure Requirements: Sellers must disclose defects that could
          affect the property's value.
        </Text>

        <Text style={styles.listItem}>
          3. Attorney Involvement: Attorney involvement is common for closing.
        </Text>

        <Text style={styles.listItem}>
          4. Buyer Beware: Alabama is a "buyer beware" or "caveat emptor" state
          which means that the buyer agrees to take possession of the property
          on an "as-is" basis. There are no guarantees made by the seller.
        </Text>

        <Text style={styles.listItem}>
          5. Known Defects: If the buyer asks a specific question about the
          property, the seller has an "obligation to disclose known facts."
        </Text>

        <Text style={styles.listItem}>
          6. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          7.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Not required but recommended to inform the buyer of any pertinent
          information about the property.
        </Text>
      </View>
    </View>
  );
};

export default Alabama;
